import { Fragment, useEffect, useState, useRef } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import Spinner from '../../../components/spinner/Spinner';
import {
	GetCampaign,
	GetCampaignKeywords,
	GetCampaignReports,
	GetReportSettings,
	GetSEOReportGridWithSproc,
	GetSEOReportKeywords,
	GetSEOReportRankWithSproc
} from '../../../Services';
import { UnixTimestampToDateTime } from '../../../utils/DateTime';
import './PublicViewCampaignReportScreenV5.css';
import { useStateValue } from '../../../StateProvider';
import { copyToClipboard } from '../../../utils/Common';
import { toast } from 'react-toastify';
import GridKeywordPickerArrowsV5 from '../../../components/gridReport/v5/gridKeywordPicker/GridKeywordPickerArrowsV5';
import GridReportToggleTabsV5 from '../../../components/gridReport/v5/gridReportToggleTabs/GridReportToggleTabsV5';
import KeywordMapStatsV5 from '../../../components/gridReport/v5/keywordMapStats/KeywordMapStatsV5';
import { actionTypes } from '../../../reducer';
import RankReportV5 from '../../../components/gridReport/v5/rankReport/RankReportV5';
import GridMapV5 from '../../../components/gridReport/v5/gridMap/GridMapV5';
import moment from 'moment';

const PublicViewCampaignReportScreenV5 = () => {
	//const [ isLoading, setIsLoading ] = useState(true);
	const [ isLoadingCampaign, setIsLoadingCampaign ] = useState(true);
	const [ isLoadingReport, setIsLoadingReport ] = useState(true);
	const [ isLoadingRanking, setIsLoadingRanking ] = useState(true);
	const { campaignId } = useParams();
	const [ campaign, setCampaign ] = useState();
	const [ campaignReports, setCampaignReports ] = useState();
	const [ report, setReport ] = useState();
	const [ reportIdValue, setReportIdValue ] = useState();
	const [ activeKeyword, setActiveKeyword ] = useState();
	const [ targetKeyword, setTargetKeyword ] = useState();
	const [ compareToKeyword, setCompareToKeyword ] = useState();
	const [ selectedReportName, setSelectedReportName ] = useState('');
	const [ compareToReportId, setCompareToReportId ] = useState('');
	const [ compareToReport, setCompareToReport ] = useState();
	const [ compareToReportName, setCompareToReportName ] = useState('');
	const [ compareToReports, setCompareToReports ] = useState();
	//const [ mobileReportView, setMobileReportView ] = useState('base');
	const [ mapFullScreen, setMapFullScreen ] = useState(false);
	const [ isCampaignCanceled, setIsCampaignCanceled ] = useState(false);
	const [ isCampaignDeleted, setIsCampaignDeleted ] = useState(false);
	const [ noReports, setNoReports ] = useState(false);
	const [ queryParameters ] = useSearchParams();
	const [ queryParamStartDate, setQueryParamStartDate ] = useState();
	const [ queryParamEndDate, setQueryParamEndDate ] = useState();
	const [ queryParamKeyword, setQueryParamKeyword ] = useState();
	const [ keywordObjects, setKeywordObjects ] = useState();
	const [ { host, user, mobileReportView }, dispatch ] = useStateValue();
	const shareLinkRef = useRef();
	const [ showShareLinkCopiedMessage, setShowShareLinkCopiedMessage ] = useState(false);
	const [ reportSettingsFormData, setReportSettingsFormData ] = useState({});
	const [ top3TotalPages, setTop3TotalPages ] = useState();
	const [ rankResponse, setRankResponse ] = useState();
	const [ compareToRankResponse, setCompareToRankResponse ] = useState();

	useEffect(() => {
		if (queryParameters) {
			setQueryParamStartDate(queryParameters.get('startDate'));
			setQueryParamEndDate(queryParameters.get('endDate'));
			setQueryParamKeyword(queryParameters.get('keyword'));

			// setQueryParamsLoaded(true);
		}
	}, []);

	useEffect(
		() => {
			if (campaignId) {
				getCampaign(campaignId);
			}
		},
		[ campaignId ]
	);

	useEffect(
		() => {
			if (campaign) {
				getCampaignReports();
				getCampaignKeywords();
				getReportSettings();
			}
		},
		[ campaign ]
	);

	useEffect(
		() => {
			if (isCampaignCanceled) {
				setIsLoadingCampaign(false);
			}
		},
		[ isCampaignCanceled ]
	);

	useEffect(
		() => {
			if (isCampaignDeleted) {
				setIsLoadingCampaign(false);
			}
		},
		[ isCampaignDeleted ]
	);

	useEffect(
		() => {
			if (noReports) {
				setIsLoadingCampaign(false);
			}
		},
		[ noReports ]
	);

	useEffect(
		() => {
			if (campaignReports && reportIdValue) {
				let currentReport = campaignReports.find((r) => r.id === reportIdValue);

				if (currentReport) {
					let tempCompareToReports = campaignReports.filter(
						(r) => r.id !== currentReport.id && r.dateUnix < currentReport.dateUnix
					);

					setCompareToReports(tempCompareToReports);

					//find the oldest report
					if (tempCompareToReports && tempCompareToReports.length > 0) {
						const oldestCompareToReport = tempCompareToReports.reduce(
							(r, o) => (o.dateCreated < r.dateCreated ? o : r)
						);

						if (queryParamStartDate) {
							setCompareToReportId(queryParamStartDate);
						} else {
							if (oldestCompareToReport) {
								setCompareToReportId(oldestCompareToReport.id);
								//getCompareToReport(oldestCompareToReport.id);
							} else {
								setCompareToReportId('0');
							}
						}
					} else {
						setCompareToReportId('0');
					}
				} else {
					setCompareToReportId('0');
				}
			} else {
				setCompareToReports();
			}
		},
		[ reportIdValue ]
	);

	useEffect(
		() => {
			if (compareToReportId && compareToReportId !== '0') {
				getReport(reportIdValue, compareToReportId);
				getCompareToReport(compareToReportId);
			} else {
				getReport(reportIdValue);
			}
		},
		[ reportIdValue, compareToReportId ]
	);

	useEffect(
		() => {
			if (report) {
				if (report.gridResponse && report.gridResponse.data && report.gridResponse.data.length > 0) {
					let currentKeywordData;

					if (queryParamKeyword) {
						currentKeywordData = report.gridResponse.data.find(
							(k) => k.keyword.toLowerCase() === queryParamKeyword.toLowerCase()
						);
					} else {
						currentKeywordData = report.gridResponse.data[0];
					}

					setTargetKeyword({
						lat              : report.gridResponse.lat,
						lng              : report.gridResponse.lng,
						horizontalPoints : report.gridResponse.horizontalPoints,
						verticalPoints   : report.gridResponse.verticalPoints,
						...currentKeywordData
					});

					setActiveKeyword(currentKeywordData.keyword);
				}

				if (!compareToReportId || compareToReportId === '0') {
					//setIsLoading(false);
					setIsLoadingReport(false);
				}
			}
		},
		[ report ]
	);

	useEffect(
		() => {
			if (
				activeKeyword &&
				compareToReport &&
				compareToReport.gridResponse &&
				compareToReport.gridResponse.data &&
				compareToReport.gridResponse.data.length > 0
			) {
				let gridDataCompareTo = compareToReport.gridResponse;
				const selectedCompareToKeyword = gridDataCompareTo.data.find((k) => k.keyword === activeKeyword);

				if (selectedCompareToKeyword) {
					setCompareToKeyword({
						lat              : gridDataCompareTo.lat,
						lng              : gridDataCompareTo.lng,
						horizontalPoints : gridDataCompareTo.horizontalPoints,
						verticalPoints   : gridDataCompareTo.verticalPoints,
						...selectedCompareToKeyword
					});
				}

				//setIsLoading(false);
				setIsLoadingReport(false);
			}
		},
		[ activeKeyword, compareToReport ]
	);

	//load rank results after grid results are loaded
	useEffect(
		() => {
			let loadRankResults = false;

			if (compareToReportId && compareToReportId !== '0') {
				if (report && compareToReport) {
					loadRankResults = true;
				}
			} else {
				if (report) {
					loadRankResults = true;
				}
			}

			if (loadRankResults) {
				getReportRankResults(reportIdValue, compareToReportId);
				getCompareReportRankResults(compareToReportId);
			}
		},
		[ report, compareToReport ]
	);

	//set loading spinner for rank results
	useEffect(
		() => {
			let rankResultsLoaded = false;

			if (compareToReportId && compareToReportId !== '0') {
				if (rankResponse && compareToRankResponse) {
					rankResultsLoaded = true;
				}
			} else {
				if (rankResponse) {
					rankResultsLoaded = true;
				}
			}

			if (rankResultsLoaded) {
				setIsLoadingRanking(false);
			}
		},
		[ rankResponse, compareToRankResponse ]
	);

	//calculate top3 total pages count
	useEffect(
		() => {
			if (rankResponse) {
				//calculate top 3 total pages for all keywords in order to be used in comments text
				if (rankResponse && rankResponse.results && rankResponse.results.length > 0) {
					//remove possible duplicate locations
					let distinctRankData = rankResponse.results.reduce((accumulator, current) => {
						if (
							!accumulator.find(
								(item) => item.keyword === current.keyword && item.location === current.location
							)
						) {
							accumulator.push(current);
						}
						return accumulator;
					}, []);

					var top3PagesData = distinctRankData.filter((r) => r.ranking && r.ranking < 4);

					setTop3TotalPages(top3PagesData && top3PagesData.length ? top3PagesData.length : null);
				}
			}
		},
		[ rankResponse ]
	);

	const getCampaign = async (id) => {
		const response = await GetCampaign(id);

		if (response) {
			if (response.status === 'Canceled') {
				setIsCampaignCanceled(true);
			} else if (response.status === 'Deleted') {
				setIsCampaignDeleted(true);
			}

			setCampaign(response);
		}

		setIsLoadingCampaign(false);
	};

	const getCampaignReports = async () => {
		if (campaign) {
			const response = await GetCampaignReports(campaign.id);

			if (response && response.reports && response.reports.length > 0) {
				let tempCampaignReports = response.reports;

				setCampaignReports(
					tempCampaignReports.filter((x) => {
						if (x.status) {
							return x.status === 'Active';
						} else {
							return x;
						}
					})
				);

				let tempReportIdValue;
				let tempCompareToReportId;

				if (queryParamEndDate) {
					tempReportIdValue = queryParamEndDate;
				} else {
					tempReportIdValue = tempCampaignReports[0].id;
				}

				if (tempReportIdValue) {
					let currentReport = tempCampaignReports.find((r) => r.id === tempReportIdValue);

					if (currentReport) {
						let tempCompareToReports = tempCampaignReports.filter(
							(r) =>
								r.id !== currentReport.id &&
								r.dateUnix < currentReport.dateUnix &&
								r.status === 'Active'
						);

						setCompareToReports(tempCompareToReports);

						//find the oldest report
						if (tempCompareToReports && tempCompareToReports.length > 0) {
							const oldestCompareToReport = tempCompareToReports.reduce(
								(r, o) => (o.dateCreated < r.dateCreated ? o : r)
							);

							if (queryParamStartDate) {
								tempCompareToReportId = queryParamStartDate;
							} else {
								if (oldestCompareToReport) {
									tempCompareToReportId = oldestCompareToReport.id;
								} else {
									tempCompareToReportId = '0';
								}
							}
						} else {
							tempCompareToReportId = '0';
						}
					} else {
						tempCompareToReportId = '0';
					}

					setReportIdValue(tempReportIdValue);
					setCompareToReportId(tempCompareToReportId);
				} else {
					setCompareToReports();
				}
			} else {
				setCampaignReports();
				setCompareToReports();

				setNoReports(true);
				setIsLoadingReport(false);
			}
		}
	};

	const getCampaignKeywords = async () => {
		if (campaign && reportIdValue) {
			const response = await GetSEOReportKeywords(campaign.id, reportIdValue);

			if (response && response.length) {
				let tempKeywords = response;

				setKeywordObjects(
					tempKeywords.sort(function(a, b) {
						return a.orderIndex - b.orderIndex;
					})
				);

				//setActiveKeyword(tempKeywords[0].keyword);
			}
		}
	};

	const getReport = async (id, compareId) => {
		setIsLoadingReport(true);

		if (campaign) {
			let targetId = campaign.googlePlaceId ? campaign.googlePlaceId : campaign.googleCid;

			let response = await GetSEOReportGridWithSproc(campaign.id, id, targetId, compareId);

			if (response.success) {
				let tempReport = response;

				tempReport.reportId = id;

				//order keywords by order index
				if (
					tempReport.gridResponse &&
					tempReport.gridResponse.data &&
					tempReport.gridResponse.data.length > 0
				) {
					let orderedKeywordsData = [];

					if (keywordObjects) {
						tempReport.gridResponse.data.forEach((gridKeywordObject) => {
							//get order index from db keywords and apply it to appropriate grid keyword
							let dbKeywordObject = keywordObjects.find((x) => x.keyword === gridKeywordObject.keyword);

							if (dbKeywordObject) {
								gridKeywordObject.orderIndex = dbKeywordObject.orderIndex;
							}

							orderedKeywordsData.push({
								...gridKeywordObject
							});
						});

						//order keywords by index
						orderedKeywordsData = orderedKeywordsData.sort(function(a, b) {
							return a.orderIndex - b.orderIndex;
						});

						tempReport.gridResponse.data = orderedKeywordsData;
					}
				}

				setReport(tempReport);
				setSelectedReportName(getReportNameByDate(tempReport.reportGeneratedAtUnix));
			} else {
				setReport();
				setReportIdValue();
			}
		}
	};

	const getCompareToReport = async (id) => {
		if (campaign) {
			let targetId = campaign.googlePlaceId ? campaign.googlePlaceId : campaign.googleCid;

			let response = await GetSEOReportGridWithSproc(campaign.id, id, targetId);

			if (response.success) {
				response.reportId = id;
				setCompareToReport(response);
				setCompareToReportName(getReportNameByDate(response.reportGeneratedAtUnix));
			} else {
				setCompareToReport();
			}
		}
	};

	const getReportRankResults = async (reportShortName, compareShortName) => {
		setIsLoadingRanking(true);

		if (campaign && campaignReports) {
			//get report id (guid)
			let currentReport = campaignReports.find((x) => x.id === reportShortName);

			if (currentReport && currentReport.recId) {
				let targetId = campaign.googlePlaceId ? campaign.googlePlaceId : campaign.googleCid;

				let response = await GetSEOReportRankWithSproc(
					campaign.id,
					currentReport.recId,
					targetId,
					compareShortName
				);

				if (response.success) {
					setRankResponse(response.rankResponse);
				}
			}
		}
	};

	const getCompareReportRankResults = async (compareShortName) => {
		if (campaign && campaignReports) {
			//get report id (guid)
			let currentReport = campaignReports.find((x) => x.id === compareShortName);

			if (currentReport && currentReport.recId) {
				let targetId = campaign.googlePlaceId ? campaign.googlePlaceId : campaign.googleCid;

				let response = await GetSEOReportRankWithSproc(campaign.id, currentReport.recId, targetId);

				if (response.success) {
					setCompareToRankResponse(response.rankResponse);
				}
			}
		}
	};

	const getReportSettings = async () => {
		let response = await GetReportSettings();

		if (response && response.data) {
			setReportSettingsFormData(response.data);
		}
	};

	const handleKeywordSelected = (keywordData) => {
		let gridData = report.gridResponse;

		setTargetKeyword({
			lat              : gridData.lat,
			lng              : gridData.lng,
			horizontalPoints : gridData.horizontalPoints,
			verticalPoints   : gridData.verticalPoints,
			...keywordData
		});

		if (compareToReport && compareToReport.gridResponse && compareToReport.gridResponse.data) {
			let gridDataCompareTo = compareToReport.gridResponse;
			const selectedCompareToKeyword = gridDataCompareTo.data.find((k) => k.keyword === keywordData.keyword);

			setCompareToKeyword({
				lat              : gridDataCompareTo.lat,
				lng              : gridDataCompareTo.lng,
				horizontalPoints : gridDataCompareTo.horizontalPoints,
				verticalPoints   : gridDataCompareTo.verticalPoints,
				...selectedCompareToKeyword
			});
		}

		setActiveKeyword(keywordData.keyword);
	};

	const getReportNameByDate = (timestamp) => {
		const format = new Intl.DateTimeFormat('en-US', {
			year  : 'numeric',
			month : 'long',
			day   : '2-digit'
		});

		return format.format(new Date(timestamp * 1000));
	};

	const handleMapFullScreen = (isMapFullScreen) => {
		setMapFullScreen(isMapFullScreen);

		if (!isMapFullScreen) {
			document.querySelector('body').scrollIntoView({
				behavior : 'instant'
			});
		}

		document.body.classList.toggle('body-full-screen');
	};

	const getReportShareUrl = () => {
		var url = new URL(`${host}/view/report/v5/${campaign.id}/`);

		url.searchParams.set('keyword', targetKeyword.keyword);

		if (compareToReportId) {
			url.searchParams.append('startDate', compareToReportId);
		}

		if (reportIdValue) {
			url.searchParams.append('endDate', reportIdValue);
		}

		return url.href;
	};

	const handleGenerateShareLink = () => {
		var url = getReportShareUrl();

		shareLinkRef.current.title = `Clik to Copy: ${url}`;

		copyToClipboard(url);

		setShowShareLinkCopiedMessage(true);

		setTimeout(function() {
			setShowShareLinkCopiedMessage(false);
		}, 2000);
	};

	return (
		<div className="mapboost-report-v5 pt-0">
			{isLoadingCampaign ? (
				<Spinner />
			) : (
				<Fragment>
					{isCampaignCanceled && (
						<Fragment>
							{user && (
								<div className="container text-start px-0 py-2">
									<h5 className="text-truncate">{campaign.name}</h5>
								</div>
							)}
							<h4 className="py-5 fs-4 fw-bold">This campaign is canceled</h4>
						</Fragment>
					)}

					{isCampaignDeleted && (
						<Fragment>
							{user && (
								<div className="container text-start px-0 py-2">
									<h5 className="text-truncate">{campaign.name}</h5>
								</div>
							)}
							<h4 className="py-5 fs-4 fw-bold">
								{user ? 'This campaign is deleted' : 'Something went wrong'}
							</h4>
						</Fragment>
					)}
				</Fragment>
			)}

			{!isCampaignCanceled &&
			!isCampaignDeleted && (
				<Fragment>
					<div className="report-header-container">
						{isLoadingCampaign ? (
							<Spinner />
						) : (
							<div className="container text-start px-0 py-2">
								{campaign && (
									<div className="row">
										<div
											className={`${mobileReportView
												? 'col-12 text-center mb-2'
												: 'col-8'} align-self-center`}
										>
											<h5 className="text-truncate">{campaign.name}</h5>
										</div>
										<div className={`${mobileReportView ? 'col-12' : 'col-4'}`}>
											<div className="report-headline-links-wrapper">
												{showShareLinkCopiedMessage && (
													<button className="btn btn-outline-success py-0 px-2 me-3">
														Copied!
													</button>
												)}

												<button
													target="_blank"
													className="btn btn-link report-headline-link"
													href="#"
													onClick={handleGenerateShareLink}
													title="Report Link"
													ref={shareLinkRef}
												>
													<i className="fa-solid fa-share-nodes" />
												</button>

												<a
													target="_blank"
													className="btn btn-link report-headline-link"
													href={
														campaign.url && campaign.url.indexOf('http') > -1 ? (
															campaign.url
														) : (
															`https://${campaign.url}`
														)
													}
													title="Directory Url"
												>
													<i className="fa-solid fa-map-location-dot" />
												</a>
												{campaign.googleCid && (
													<a
														target="_blank"
														className="btn btn-link report-headline-link"
														href={`https://google.com/maps/?cid=${campaign.googleCid}`}
														title="Google Profile"
													>
														<i className="fa-brands fa-google" />
													</a>
												)}
											</div>
										</div>
									</div>
								)}
							</div>
						)}

						{noReports && <div className="no-reports-notice">No reports</div>}

						{isCampaignCanceled && (
							<div className="canceled-campaign-warning">This campaign is currently inactive</div>
						)}

						{!!campaignReports &&
						campaignReports.length > 0 && (
							<div className={`${mobileReportView ? '' : 'report-keyword-container'} container mb-3`}>
								{isLoadingReport ? (
									<Spinner />
								) : (
									<Fragment>
										{report &&
										report.gridResponse &&
										report.gridResponse.data && (
											<div className="row">
												<div className={`${mobileReportView ? 'col-12 p-0' : 'col-12'}`}>
													<GridKeywordPickerArrowsV5
														campaign={campaign}
														gridData={report.gridResponse}
														activeKeywordData={targetKeyword}
														onKeywordSelected={handleKeywordSelected}
														mapFullScreen={mapFullScreen}
													/>
												</div>
											</div>
										)}
									</Fragment>
								)}
							</div>
						)}
					</div>

					<div className="report-body">
						{mobileReportView ? (
							<Fragment>
								<div className="container campaign-reports mb-3">
									<div className="row">
										{!!compareToReports &&
										compareToReports.length > 0 &&
										compareToKeyword && (
											<div className="col-12">
												<div className="mb-3">
													<select
														className="form-select"
														onChange={(e) => {
															setCompareToReportId(e.target.value);
														}}
														value={compareToReportId}
													>
														<option value="" disabled>
															Compare to...
														</option>
														{compareToReports.map((report) => (
															<option value={report.id} key={report.id}>
																{UnixTimestampToDateTime(report.dateUnix)}
															</option>
														))}
													</select>
												</div>
											</div>
										)}

										<div className="col-12">
											<div className="mb-1">
												<select
													value={reportIdValue}
													className="form-select"
													onChange={(e) => {
														setReportIdValue(e.target.value);
														setCompareToReportId('');
														setReport();
														//setIsLoading(true);
														setIsLoadingReport(true);
													}}
												>
													{!!campaignReports &&
														campaignReports.length > 0 &&
														campaignReports.map((report) => (
															<option value={report.id} key={report.id}>
																{UnixTimestampToDateTime(report.dateUnix)}
															</option>
														))}
												</select>
											</div>
										</div>
									</div>
								</div>

								<div className="container campaign-reports mb-3">
									<div className="row">
										<GridReportToggleTabsV5
											reportName={selectedReportName}
											compareToReportName={compareToReportName}
										/>
									</div>

									<div className="row">
										{!!compareToReports &&
										compareToReports.length > 0 &&
										compareToKeyword &&
										mobileReportView === 'compare' && (
											<div className="col-12">
												<div className="mb-3">
													<KeywordMapStatsV5
														keywordData={compareToKeyword}
														mobileReportView={mobileReportView}
													/>

													<div className="map-wrapper mb-1">
														<GridMapV5
															key="map-1"
															gridData={compareToKeyword}
															placeId={campaign.googlePlaceId}
															placeCid={campaign.googleCid}
															isFullHeight={mapFullScreen}
															reportSettings={reportSettingsFormData}
														/>
													</div>
												</div>
											</div>
										)}

										<div className="col-12">
											{targetKeyword &&
											mobileReportView === 'base' && (
												<div className="col-12">
													<div className="mb-3">
														<KeywordMapStatsV5
															keywordData={targetKeyword}
															mobileReportView={mobileReportView}
														/>
													</div>

													<div className="map-wrapper mb-1">
														<GridMapV5
															key="map-0"
															gridData={targetKeyword}
															placeId={campaign.googlePlaceId}
															placeCid={campaign.googleCid}
															isFullHeight={mapFullScreen}
															reportSettings={reportSettingsFormData}
														/>
													</div>
												</div>
											)}
										</div>
									</div>
								</div>

								<div className="container campaign-reports">
									{rankResponse && (
										<RankReportV5
											rankData={rankResponse}
											compareToRankData={compareToRankResponse}
											targetKeyword={activeKeyword}
											campaign={campaign}
										/>
									)}
								</div>
							</Fragment>
						) : (
							<Fragment>
								<div className="container mb-3">
									<div className="row">
										{isLoadingReport && (
											<Fragment>
												{!!compareToReports && compareToReports.length > 0 ? (
													<Fragment>
														<div className="col-lg-6 col-12 p-0">
															<div className="campaign-reports me-2 py-5">
																<Spinner />
															</div>
														</div>
														<div className="col-lg-6 col-12 p-0">
															<div className="campaign-reports py-5">
																<Spinner />
															</div>
														</div>
													</Fragment>
												) : (
													<div className="col-12 p-0">
														<div className="campaign-reports py-5">
															<Spinner />
														</div>
													</div>
												)}
											</Fragment>
										)}

										{!isLoadingReport && (
											<Fragment>
												<div className="col-lg-6 col-12 p-0">
													<Fragment>
														{!!campaignReports &&
														campaignReports.length > 0 &&
														compareToReport &&
														!!compareToReports &&
														compareToReports.length > 0 &&
														compareToKeyword && (
															<div className="campaign-reports me-2">
																<div className="mb-3">
																	<select
																		className="form-select"
																		onChange={(e) => {
																			setCompareToReportId(e.target.value);
																		}}
																		value={compareToReportId}
																	>
																		<option value="" disabled>
																			Compare to...
																		</option>
																		{compareToReports.map((report) => (
																			<option value={report.id} key={report.id}>
																				{UnixTimestampToDateTime(
																					report.dateUnix
																				)}
																			</option>
																		))}
																	</select>
																</div>

																{(!mobileReportView ||
																	mobileReportView === 'compare') && (
																	<div className="mb-3">
																		<KeywordMapStatsV5
																			keywordData={compareToKeyword}
																			mobileReportView={mobileReportView}
																		/>
																	</div>
																)}

																<div className="map-wrapper mb-1">
																	<GridMapV5
																		key="map-1"
																		gridData={compareToKeyword}
																		placeId={campaign.googlePlaceId}
																		placeCid={campaign.googleCid}
																		isFullHeight={mapFullScreen}
																		reportSettings={reportSettingsFormData}
																	/>
																</div>
															</div>
														)}
													</Fragment>
												</div>

												{!!campaignReports &&
												campaignReports.length > 0 && (
													<div
														className={`${!!compareToReports &&
															compareToReports.length > 0 &&
															'col-lg-6'} col-12 p-0`}
													>
														<div
															className={`campaign-reports ${!!compareToReports &&
																compareToReports.length > 0 &&
																'ms-2'}`}
														>
															<div className="mb-3">
																<select
																	value={reportIdValue}
																	className="form-select"
																	onChange={(e) => {
																		setReportIdValue(e.target.value);
																		setCompareToReportId('');
																		setReport();
																		//setIsLoading(true);
																		setIsLoadingReport(true);
																	}}
																>
																	{campaignReports.map((report) => (
																		<option value={report.id} key={report.id}>
																			{UnixTimestampToDateTime(report.dateUnix)}
																		</option>
																	))}
																</select>
															</div>

															{report &&
															report.gridResponse &&
															targetKeyword &&
															(!mobileReportView || mobileReportView === 'base') && (
																<div className="mb-3">
																	<KeywordMapStatsV5
																		keywordData={targetKeyword}
																		mobileReportView={mobileReportView}
																	/>
																</div>
															)}

															<div className="map-wrapper mb-1">
																<GridMapV5
																	key="map-0"
																	gridData={targetKeyword}
																	placeId={campaign.googlePlaceId}
																	placeCid={campaign.googleCid}
																	isFullHeight={mapFullScreen}
																	reportSettings={reportSettingsFormData}
																	isSinglePublicView={
																		!!compareToReports &&
																		compareToReports.length > 0 ? (
																			false
																		) : (
																			true
																		)
																	}
																/>
															</div>
														</div>
													</div>
												)}
											</Fragment>
										)}
									</div>
								</div>

								<div className="container mb-3 p-0">
									{isLoadingRanking ? (
										<div className="campaign-reports">
											<Spinner />
										</div>
									) : (
										<Fragment>
											{!!campaignReports &&
											campaignReports.length > 0 && (
												<div className="campaign-reports">
													{rankResponse && (
														<RankReportV5
															rankData={rankResponse}
															compareToRankData={compareToRankResponse}
															targetKeyword={activeKeyword}
															campaign={campaign}
														/>
													)}
												</div>
											)}
										</Fragment>
									)}
								</div>
							</Fragment>
						)}
					</div>

					<div className="container-fluid text-start mb-2">
						<div className="container">
							<div className="row">
								<div className="col-12 ps-0">
									<label>Next Report Date:</label>
									<label className="ms-3">
										{campaign && campaign.nextReportDate ? (
											moment(campaign.nextReportDate).format('yyyy-MM-DD')
										) : (
											''
										)}
									</label>
								</div>
							</div>
						</div>
					</div>
				</Fragment>
			)}
		</div>
	);
};

export default PublicViewCampaignReportScreenV5;
